import { Link } from "react-router-dom";
import mainLogo from "../../asset/images/generals/main-logo.png";
import {
  ABOUT_US,
  CONTACT_US,
  HOME,
  KEY_PERSONNEL,
  RESOURCES,
  SERVICES,
} from "../../constants/translations";
import {
  ABOUT_US_ROUTE,
  CONTACT_US_ROUTE,
  HOME_ROUTE,
  KEY_PERSONNEL_ROUTE,
  RESOURCES_ROUTE,
  SERVICES_ROUTE,
} from "../../routes/routes";

import scrollToTop from "../functions/scrollToTop";
import { useState } from "react";
import { FaBars } from "react-icons/fa";

const MenuItem = ({ item, closeMenu }) => {
  return (
    <li className="main-menu-item-li">
      <Link
        className="main-menu-item"
        to={item.link}
        onClick={() => {
          closeMenu(false);
          scrollToTop();
        }}
      >
        {item.text}
      </Link>
    </li>
  );
};

const Header = () => {
  const menuItems = [
    {
      id: 0,
      link: HOME_ROUTE,
      text: HOME,
    },
    {
      id: 1,
      link: ABOUT_US_ROUTE,
      text: ABOUT_US,
    },
    {
      id: 2,
      link: SERVICES_ROUTE,
      text: SERVICES,
    },
    {
      id: 3,
      link: RESOURCES_ROUTE,
      text: RESOURCES,
    },
    {
      id: 4,
      link: KEY_PERSONNEL_ROUTE,
      text: KEY_PERSONNEL,
    },
    {
      id: 6,
      link: CONTACT_US_ROUTE,
      text: CONTACT_US,
    },
  ];
  const [showMenu, setShowMenu] = useState(false);
  return (
    <header className="main-header">
      <div className="header-content mm-width">
        <Link to="/" className="main-logo" onClick={scrollToTop}>
          <img src={mainLogo} alt="DalBahr" width={140} height={46} />
        </Link>
        <button
          className="show-responsive-menu"
          onClick={() => {
            setShowMenu(!showMenu);
          }}
        >
          <FaBars />
        </button>
        <nav className="main-nav">
          <ul
            className={`main-menu-item-ul ${showMenu ? "responsive-menu" : ""}`}
          >
            {menuItems.map((mi) => (
              <MenuItem item={mi} key={mi.id} closeMenu={setShowMenu} />
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
